import React, {useContext} from "react";
import {observer} from "mobx-react";

import "./StageCorner.scss";
import StoreContext from "@/stores/StoreContext";

export default observer(function StageCorner(): JSX.Element | null {
  const store = useContext(StoreContext);
  const {stageStore} = store;
  const show = !store.stageStore.isProduction;

  if (!show) return null;
  return (
    <svg className="StageCorner" width="100" height="100" viewBox="0 0 100 100" aria-hidden="true">
      <text className="text" x="50%" y="90%">
        {stageStore.stage.displayName}
      </text>
    </svg>
  );
});
